
import React from 'react';
import CalculatorCard from './CalculatorCard';

export interface CalculatorItem {
  title: string;
  description: string;
  icon: string;
  path: string;
  available: boolean;
}

interface CalculatorCategoryProps {
  title: string;
  description: string;
  calculators: CalculatorItem[];
}

const CalculatorCategory = ({ title, description, calculators }: CalculatorCategoryProps) => {
  return (
    <div className="mb-12">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h2 className="text-2xl font-semibold">{title}</h2>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {calculators.map((calc, index) => (
          <CalculatorCard
            key={index}
            title={calc.title}
            description={calc.description}
            icon={calc.icon}
            path={calc.path}
            available={calc.available}
          />
        ))}
      </div>
    </div>
  );
};

export default CalculatorCategory;
